import { jsxs, jsx } from 'react/jsx-runtime';
import Ellipsis, { EllipsisContainer } from '../Ellipsis/Ellipsis.js';

/**
 * Display 16 dots which stands for the credit card number.
 * If lastFourDigits is a non-empty string, display 12 dots + these lastFourDigits.
 */
const MaskedCreditCardNumber = ({ theme, lastFourDigits }) => {
    return (jsxs(EllipsisContainer, { theme: theme, children: [jsx(Ellipsis, { identifier: "firstFour" }), jsx(Ellipsis, { identifier: "secondFour" }), jsx(Ellipsis, { identifier: "thirdFour" }), jsx("span", { className: "lastFourDigits", children: lastFourDigits || jsx(Ellipsis, { identifier: "fourthFour" }) })] }));
};

export { MaskedCreditCardNumber as default };
//# sourceMappingURL=MaskedCreditCardNumber.js.map
